// extracted by mini-css-extract-plugin
module.exports = {"sectionSolutuinList":"Index_sectionSolutuinList_1DOF_"};